export const HasContactOptions = [
  { label: "-", value: "" },
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
]